export default "__VITE_ASSET__RL1D4SAy__"